import { Crown } from "lucide-react";

const PageHeader = () => {
  return (
    <div className="bg-white border-b border-slate-200">
      <div className="w-full px-4">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-3">
            <Crown className="h-8 w-8 text-indigo-600" />
            <h1 className="text-2xl font-semibold text-indigo-900">ממשק ניהול Super Admin</h1>
          </div>
          <div className="text-sm text-slate-600">ניהול מערכת מתקדם</div>
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
